import { useState } from 'react'

/**
 * React hook useLocalStorage allow to work with sessionStorage properly
 * @param {string} key - key of sessionStorageItem
 * @param initialValue - could have any type(initial value of sessionStorage item)
 * @return [value, updateValue, removeValue] - return the value, function to update it, and function to remove it
 *
 * example: const [count, setCount, removeCount] = useSessionStorage('count', 0);
 *
 */

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const useSessionStorage = (key, initialValue) => {
  const storedValue = sessionStorage.getItem(key)
  const initial = storedValue ? JSON.parse(storedValue) : initialValue

  const [value, setValue] = useState(initial)

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const updateValue = (newValue) => {
    setValue(newValue)
    sessionStorage.setItem(key, JSON.stringify(newValue))
  }

  const removeValue = () => {
    setValue(initialValue)
    sessionStorage.removeItem(key)
  }

  return [value, updateValue, removeValue]
}
